var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("mealAllowance.BoxWrap.manage") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.searchVal,
                    size: "small",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("mealAllowance.form.empNo") } },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.empNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "empNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("mealAllowance.form.empName") } },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.empName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "empName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "flexRow",
                      attrs: { label: _vm.$t("mealAllowance.form.date") },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "startDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.startDay,
                              valueformat: "yyyyMMdd",
                              "picker-options": _vm.startPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchVal,
                                  "startDay",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "endDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.endDay,
                              valueformat: "yyyyMMdd",
                              "picker-options": _vm.endPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.searchVal, "endDay", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.teamType == "GLOBAL"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mealAllowance.form.teamType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "mealAllowance.form.optionPlaceholder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.teamType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "teamType", $$v)
                                },
                                expression: "searchVal.teamType",
                              },
                            },
                            _vm._l(
                              _vm.lookupList["TEAM_TYPE"],
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("mealAllowance.BoxWrap.list") },
        },
        [
          _c(
            "div",
            { attrs: { slot: "header-right" }, slot: "header-right" },
            [
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT2"] },
                        expression: "{pageName, list: ['EXPORT2']}",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel2(
                          _vm.$t(
                            "mealAllowance.common.exportMealSupplementText"
                          )
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.exportMealSupplement")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{pageName, list: ['EXPORT']}",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel(
                          _vm.$t("mealAllowance.common.exportText")
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.export")))]
                ),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.table.listLoading,
                  expression: "table.listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.table.list,
                stripe: "",
                border: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "signRecordNo",
                  label: _vm.$t("mealAllowance.table.signRecordNo"),
                  width: "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dateCycle",
                  label: _vm.$t("mealAllowance.table.dateCycle"),
                  width: "250",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dayFormatted",
                  label: _vm.$t("mealAllowance.table.dayFormatted"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("mealAllowance.table.empNo"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("mealAllowance.table.empName"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "planTaskType",
                  label: _vm.$t("mealAllowance.table.planTaskType"),
                  width: "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "combineAddress",
                  label: _vm.$t("mealAllowance.table.combineAddress"),
                  width: "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "combineCheckInAddress",
                  label: _vm.$t("mealAllowance.table.combineCheckInAddress"),
                  width: "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "taskCheckInDatetime",
                  label: _vm.$t("mealAllowance.table.taskCheckInDatetime"),
                  width: "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "checkInDatetime",
                  label: _vm.$t("mealAllowance.table.checkInDatetime"),
                  width: "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalMeal",
                  label: _vm.$t("mealAllowance.table.totalMeal"),
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "mealRemark",
                  label: _vm.$t("mealAllowance.table.mealRemark"),
                  width: "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.table.total > 0,
                expression: "table.total>0",
              },
            ],
            attrs: {
              total: _vm.table.total,
              page: _vm.table.currPage,
              limit: _vm.table.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.table, "currPage", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.table, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }